import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const MenuLink = (props) => (
    <li
        onClick={props.setParams}
        className={props.className}
        style={props.style}
    >
        <NavLink
            to={{
                pathname: props.pathname,
                search: props.search,
            }}
            isActive={props.isActive}
        >
            {props.name}
        </NavLink>
    </li>
);

export default MenuLink;



/** WEBPACK FOOTER **
 ** ./src/components/shared/secondary-menu/menu-link.jsx
 **/